<div class="position-relative" style="cursor: pointer;" ngbDropdown container="body" [autoClose]="'outside'"
    (openChange)="onDropdownOpenChange($event)">
    <div class="d-flex align-items-center justify-content-between" ngbDropdownToggle>
        <span [class.fw-bold]="isFilterActive" [class.text-danger]="isFilterActive">{{ label }}</span>
        <i class="ft-filter small" [class.text-danger]="isFilterActive" [class.fw-bold]="isFilterActive"></i>
    </div>
    <div ngbDropdownMenu class="shadow border-0 p-2" style="min-width: 240px;">
        <!-- Sort Section -->
        <div class="d-flex flex-column gap-1 mb-2">
            <button class="btn w-100 text-start p-1 d-flex align-items-center" (click)="onSort(false)">
                <div class="bg-white border rounded d-flex align-items-center justify-content-center me-2 text-dark"
                    style="width: 24px; height: 24px;">
                    <i class="ft-arrow-up" style="font-size: 0.7rem;"></i>
                </div>
                <span class="small">{{ isDate ? 'Sort Oldest to Newest' : 'Sort A to Z' }}</span>
            </button>
            <button class="btn w-100 text-start p-1 d-flex align-items-center" (click)="onSort(true)">
                <div class="bg-white border rounded d-flex align-items-center justify-content-center me-2 text-dark"
                    style="width: 24px; height: 24px;">
                    <i class="ft-arrow-down" style="font-size: 0.7rem;"></i>
                </div>
                <span class="small">{{ isDate ? 'Sort Newest to Oldest' : 'Sort Z to A' }}</span>
            </button>
        </div>
        <div class="dropdown-divider mb-2"></div>

        <!-- Filter Section -->

        <!-- Text Filter Mode (Title) -->
        <div *ngIf="isTextFilter; else listFilterMode">
            <label class="small text-muted mb-1" style="font-size: 0.75rem;">Text Filter:</label>
            <input type="text" class="form-control form-control-sm mb-1" placeholder="Contains..."
                [ngModel]="currentTitleFilter" (ngModelChange)="onTitleChange($event)">
        </div>

        <!-- List Filter Mode (Default) -->
        <ng-template #listFilterMode>
            <!-- Search Box for List -->
            <input type="text" class="form-control form-control-sm mb-2" placeholder="Search..."
                [(ngModel)]="searchTerm">

            <!-- Unified List Container -->
            <div class="border rounded">
                <!-- Select All Header -->
                <div class="px-2 py-1 border-bottom bg-light rounded-top">
                    <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" [id]="'select-all-' + field"
                            [checked]="isAllSelected" (change)="onSelectAll($event)">
                        <label class="form-check-label small fw-bold" [for]="'select-all-' + field"
                            style="font-size: 0.8rem;">
                            Select All
                        </label>
                    </div>
                </div>

                <!-- Scrollable List Body -->
                <div class="filter-list px-2 py-1" style="max-height: 200px; overflow-y: auto;">
                    <div class="form-check mb-0" *ngFor="let val of displayedValues">
                        <input class="form-check-input" type="checkbox" [id]="'filter-' + field + '-' + val"
                            [checked]="isChecked(val)" (change)="onCheckChange(val, $event)">
                        <label class="form-check-label small" [for]="'filter-' + field + '-' + val"
                            style="font-size: 0.85rem;">
                            {{ val || '(Empty)' }}
                        </label>
                    </div>
                    <div class="text-muted small text-center py-2" *ngIf="displayedValues.length === 0">
                        No matches
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Clear Filter Footer -->
        <div *ngIf="isFilterActive" class="mt-2 pt-2 border-top text-end">
            <button class="btn btn-sm btn-link text-danger p-0 text-decoration-none" (click)="onClear()"
                style="font-size: 0.85rem;">
                <i class="ft-x me-1"></i> Clear Filter
            </button>
        </div>
    </div>
</div>